export default "__VITE_ASSET__DTJ87aac__"